import { useState } from 'react';
import { Star } from 'lucide-react';
import { Card, CardHeader } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { EmptyState } from '@/components/ui/EmptyState';
import { ModuleTogglePanel } from '@/components/dashboard/ModuleTogglePanel';

/**
 * cogs/starboard.py's DashboardConfig exposes only the master toggle
 * (`_dashboard_get_states` -> `{"_master": settings["enabled"]}`) — emoji
 * and threshold live in starboard_settings but have no Bridge field yet,
 * so they stay as a disabled preview rather than a fake-working control.
 */
export function StarboardPage() {
  const [emoji, setEmoji] = useState('⭐');
  const [threshold, setThreshold] = useState('5');

  return (
    <div className="space-y-6">
      <ModuleTogglePanel module="starboard" title="Starboard" permissionNote="Administrator permission required." />

      <Card>
        <CardHeader title="Settings" description="Emoji/threshold aren't connected to the Bridge yet." />
        <div className="grid grid-cols-2 gap-3 max-w-xs opacity-60">
          <div>
            <label className="text-small text-text-secondary block mb-1">Emoji</label>
            <Input value={emoji} onChange={(e) => setEmoji(e.target.value)} disabled />
          </div>
          <div>
            <label className="text-small text-text-secondary block mb-1">Threshold</label>
            <Input type="number" min={1} value={threshold} onChange={(e) => setThreshold(e.target.value)} disabled />
          </div>
        </div>
      </Card>

      <Card>
        <CardHeader title="Hall of fame" description="Most-starred messages." />
        <EmptyState icon={Star} title="No starred messages yet" />
      </Card>
    </div>
  );
}
